<div class="aumico-logged-out-root">
    <img class="vectorbg" src="assets/loggedOutLeftThemeVector.svg" />
    <div class="aumico-logged-out-left-side">
        <div class="aumico-logged-out-left-side-container">
            <ng-container *ngIf="!!introductionText">
                {{ introductionText }}
            </ng-container>
            <ng-container *ngIf="!introductionText">
                <ng-content select="[aumico-logged-out-layout-side-content]"></ng-content>
            </ng-container>
        </div>
    </div>
    <div class="aumico-logged-out-right-side">
        <div class="aumico-logo-section">
            <div class="aumico-logo">
                <img src="assets/aumico-logo-4c.svg" />
            </div>
        </div>
        <div class="page-content">
            <ng-content></ng-content>
        </div>
        <!-- < logged-out-layout-footer> -->
        <div class="footer-position">
            <aumico-logged-out-footer>
                <ng-content select="[aumico-logged-out-footer]"></ng-content>
            </aumico-logged-out-footer>
        </div>

        <!-- <app-component-aumico-logged-out-footer></app-component-aumico-logged-out-footer> -->
    </div>
</div>
